import storage from './storage';

const { REACT_APP_API_URL: apiUrl } = process.env;

async function parseJSON(response) {
  if (!response.ok && !response.body) {
    return null;
  }

  if (response.status === 204 || response.status === 205) {
    return true;
  }

  const json = await response.json();
  json.meta = response;

  return json;
}

function checkAuth(response) {
  if (response.status === 401) {
    // remove session from store/localStorage, redirect to login
    storage.local.clear('userId');
    storage.local.clear('sellerId');
    storage.local.clear('auth_token');

    window.location.href = '/login';

    return response;
  }

  return response;
}

export default function request(url, token, options = {}) {
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(checkAuth)
    .then(parseJSON);
}

export async function fetcher(url, token, options = {}) {
  return fetch(apiUrl + url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(checkAuth)
    .then(parseJSON)
    .then(res => {
      if (res === true) return true;
      if (res === null) return null;
      if (res.data) return res.data;

      throw res || res.message;
    });
}

/* 
  use with useInfiniteQuery (react-query)
*/
export async function fetchInfinite(url, token, options = {}) {
  return fetch(apiUrl + url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(checkAuth)
    .then(parseJSON)
    .then(res => {
      if (res.data) return res;

      throw new Error(res.error || res.message);
    })
    .catch(error => {
      throw new Error(error?.error || error?.message);
    });
}
